// TEMPLATE — operator approval pending (#6069, 2026-10-20).
//
// The per-business Privacy Policy and Text Message Terms served at
// /business/:companyId/privacy and /business/:companyId/terms. Each contractor's
// SMS registration (toll-free verification / 10DLC) needs THE CONTRACTOR'S own
// privacy and terms URLs, so this text is written in the business's voice and
// names the business — never the platform (Twilio 30506; see BusinessPage.js).
//
// This is ALL of the wording. Change it here and nowhere else. It is a plain
// starting template, not legal advice and not a compliance guarantee; the
// operator approves the wording before anyone relies on it.
//
// Every section is a function of `b`, the business details:
//   b.name    — the trading name shown on the business page
//   b.legal   — the legal entity name (may equal b.name)
//   b.email, b.phone, b.website, b.address — may be empty strings

export const LEGAL_LAST_UPDATED = 'October 20, 2026';

const contactLine = (b) => {
  const parts = [];
  if (b.email) parts.push(`email ${b.email}`);
  if (b.phone) parts.push(`call ${b.phone}`);
  if (b.address) parts.push(`write to ${b.address}`);
  return parts.length
    ? `To contact ${b.name}, ${parts.join(', or ')}.`
    : `To contact ${b.name}, use the contact details on our business page.`;
};

export const privacySections = (b) => [
  {
    heading: 'Who we are',
    body: [
      `This privacy policy explains how ${b.legal}${b.legal !== b.name ? ` (trading as ${b.name})` : ''} ` +
        `collects and uses information when you request work, receive a quote or invoice, ` +
        `or receive text messages from us.`
    ]
  },
  {
    heading: 'What we collect',
    body: [
      'Your name, phone number, email address and service address.',
      'Details of the work you ask us to do, appointments, quotes, invoices and payments.',
      'Messages you send us, and your text message consent and opt-out choices.'
    ]
  },
  {
    heading: 'How we use it',
    body: [
      'To provide the service you asked for: scheduling appointments, sending quotes and ' +
        'invoices, taking payment, and keeping you updated about your job.',
      'To answer your questions and keep records of the work we have done.'
    ]
  },
  {
    heading: 'Mobile numbers and text messages',
    body: [
      'Mobile numbers and text message consent are not shared with or sold to third parties ' +
        'or affiliates for marketing or promotional purposes.',
      'We only share information with service providers that help us run our business ' +
        '(for example, sending messages, processing payments or hosting our records), and ' +
        'only so they can provide that service to us.'
    ]
  },
  {
    heading: 'Opting out',
    body: [
      'Reply STOP to any text message from us to stop receiving texts. Reply HELP for help.',
      'You can also ask us to stop contacting you, or ask what information we hold about you, ' +
        'using the contact details below.'
    ]
  },
  {
    heading: 'Contact us',
    body: [contactLine(b)]
  }
];

export const termsSections = (b) => [
  {
    heading: 'Text message program',
    body: [
      `${b.name} sends text messages about your service: appointment confirmations and ` +
        `reminders, quotes, invoices, payment receipts and updates about work in progress. ` +
        `We do not send marketing texts.`,
      'You receive these messages only if you gave us your mobile number and agreed to ' +
        'receive texts about your job.'
    ]
  },
  {
    heading: 'Message frequency and cost',
    body: [
      'Message frequency varies with your appointments and jobs.',
      'Message and data rates may apply.'
    ]
  },
  {
    heading: 'Stopping messages and getting help',
    body: [
      'Reply STOP to any message to opt out. We will send one message confirming you have ' +
        'been unsubscribed, and no further texts after that.',
      `Reply HELP for help, or contact ${b.name} directly. ${contactLine(b)}`
    ]
  },
  {
    heading: 'Carriers',
    body: ['Carriers are not liable for delayed or undelivered messages.']
  },
  {
    heading: 'Privacy',
    body: ['See our Privacy Policy for how we handle your information.']
  }
];
